module.exports = require('../../full/instance/every');
